<app-go-back [route]="'/login'"></app-go-back>
<section>
  <img class="mobydyg-logo" src="../../../assets/static/mobydyg.png" alt="MobyDyg Logo">
  <app-send-code class="send-code" (passworPage)="passwordPage($event)" (userEmail)="emailToValid = $event" (deliveryInfo)="onDeliveryInfo($event)" [codePageActive]="codePage"
    *ngIf="codePage == true" [@inOutAnimation]></app-send-code>
  <app-change-password (codePage)="passwordPage($event)" [emailToValid]="emailToValid" [deliveryInfo]="recoveryDeliveryInfo" [PasswordPageActive]="codePage"
    *ngIf="codePage == false" [@inOutAnimation]></app-change-password>
</section>
